









































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PRODUCTS_GET_ALL, PRODUCTS_SET_CURRENT } from '../config/constants';

const product = namespace('product');

@Component({
  components: {}
})
export default class ProductAndCountrySelector extends Vue {
  private productId: string | null = null;
  private product: any | null = null;
  private country: string | null = '';
  private countries: string[] | null = null;

  private disabled: boolean = true;

  @product.Getter('getCompleteProduct') completeProduct!: (pid: string) => any;
  @product.State(x => x.products) products!: any[];

  async setCurrent(p: { product?: any; country?: string }) {
    return await this.$store.dispatch(PRODUCTS_SET_CURRENT, {
      product: this.product,
      country: this.country
    });
  }

  replaceParams(k: { key: 'product' | 'country'; value: string }) {
    return this.$router.replace({
      params: { ...this.$route.params, [k.key]: k.value },
      query: this.$route.query
    });
  }

  async mounted() {
    try {
      await this.$store.dispatch(PRODUCTS_GET_ALL);
      this.disabled = false;

      const { product, country } = this.$route.params;
      if (product) {
        this.productId = product;
        this.product = this.completeProduct(this.productId);
        if (this.product) {
          if (this.product.countries.includes(country)) {
            this.countries = this.product.countries;
            this.country = country;

            await this.setCurrent({
              product: this.product,
              country: this.country
            });
          }
        }
      }
    } catch (error) {
      this.$store.dispatch('alerts/warning', 'Unable to retrieve products. Please reload!');
    }
  }

  @Watch('productId')
  onProductIdChange(pid: string) {
    this.replaceParams({ key: 'product', value: pid });
  }

  @Watch('country')
  async onCountryChange(country: string) {
    if (country) {
      if (this.product && this.product.countries.includes(country)) {
        try {
          await this.setCurrent({ product: this.product, country });
          await this.replaceParams({ key: 'country', value: country });
        } catch (error) {}
      }
    }
  }

  @Watch('product')
  onProductChange(product: any) {
    if (product) {
      if (product.countries) {
        this.countries = product.countries;
      }
      if (product._id) {
        this.productId = product._id;
      }

      if (this.country) {
        this.setCurrent({ product: product, country: this.country });
      }
    }
  }
}
